import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { isBigCompanyOrder } from "@/constants/vip";
import { cancelBizOrder, getBizOrderList, getOrder } from "@/services";
import { Button, Col, Row } from "antd";
import Router from "next/router";
import styles from "./index.module.less";

export const OrderConfirm = ModalWrap(function OrderConfirmDialog({
  order,
  onOk,
  onCancel,
  onLook, // 查看待支付订单
  ...props
}) {
  const isPublicTransfer =
    order.charges[0]?.payment_method_detail?.name?.includes("线下支付-转账");
  return (
    <HBModal
      {...props}
      footer={null}
      title={null}
      width={480}
      onCancel={onCancel}
    >
      <div className={styles.orderConfirm}>
        <div className={styles.title}>提示</div>
        <div className={styles.content}>
          <h3>
            {isPublicTransfer
              ? "你有「对公转账订单」，若已转账请勿重新订购"
              : "你有待支付订单，是否取消订单重新订购？"}
          </h3>
          {/* {isPublicTransfer && ( */}
          <div className={styles.desc}>
            {`点击重新订购，${
              isPublicTransfer ? "对公转账订单" : "待支付订单"
            }将会被取消`}
          </div>
          {/* )} */}
          <div className={styles.card}>
            <Row className={styles.cardHeader}>
              <Col span={16}>订单号：{order.order_no}</Col>
              <Col span={8} className={styles.warn}>
                待支付
              </Col>
            </Row>
            <Row className={styles.cardBody}>
              <Col span={16}>
                {order.skus.map((sku) => sku.ref_body.name).join("、")}
              </Col>
              <Col span={8} className={styles.price}>
                <div>¥{order.amount}</div>
                {order.original_amount - order.amount > 0 && (
                  <div>
                    (已抵扣¥{(order.original_amount - order.amount).toFixed(2)})
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            width="40"
            onClick={() => {
              onCancel();
              onLook && onLook();
            }}
            style={{ marginRight: "8px" }}
          >
            {isPublicTransfer ? "查看对公转账订单" : "查看待支付订单"}
          </Button>
          {/* 大企业会员相关订单不给取消 */}
          {!isBigCompanyOrder(order) && (
            <Button
              width="40"
              type={"primary"}
              onClick={() => {
                onOk && onOk();
              }}
            >
              重新订购
            </Button>
          )}
        </div>
      </div>
    </HBModal>
  );
});

export default async function orderCheck() {
  const { list } = await getBizOrderList({
    status: 0,
  });

  const notSubscribeOrders = list.filter((order) => {
    return !order.skus.find((sku) => sku?.ref_body?.goods?.is_auto_renew);
  });

  return new Promise(async (resolve, reject) => {
    if (notSubscribeOrders.length > 0) {
      const orderDetail = await getOrder(notSubscribeOrders[0].order_no);

      OrderConfirm.open({
        order: orderDetail,
        async onOk() {
          // 继续结算
          const res = await cancelBizOrder({
            order_no: notSubscribeOrders[0].order_no,
          });
          if (res.err) {
            reject();
          } else {
            resolve();
          }
        },
        onLook() {
          reject();
          Router.push("/me/order");
        },
        onCancel() {
          reject();
        },
      });
    } else {
      resolve();
    }
  });
}
